import { PositiveFill, NegativeFillDiamond } from 'ui/icons';
import { colors } from 'ui/theme';
import { TableCell } from 'ui/tableCell';
import { ColumnData } from './types';

export const COLUMNS: ColumnData[] = [
  {
    name: 'Record Name',
    align: 'flex-start',
    value: 'recordName',
    sortable: false,
    RowCell: ({ row }) => <TableCell>{row.recordName}</TableCell>,
  },
  {
    name: 'Record Type',
    align: 'flex-start',
    value: 'recordType',
    sortable: false,
    RowCell: ({ row }) => <TableCell>{row.recordType}</TableCell>,
  },
  {
    name: 'Record Value',
    align: 'flex-start',
    value: 'recordValue',
    sortable: false,
    RowCell: ({ row }) => <TableCell>{row.recordValue}</TableCell>,
  },
  {
    name: 'Verified',
    align: 'flex-start',
    value: 'hasEntry',
    sortable: false,
    RowCell: ({ row }) => (
      <TableCell>
        {row.hasEntry ? (
          <>
            <PositiveFill color={colors.green100} /> Yes
          </>
        ) : (
          <>
            <NegativeFillDiamond color={colors.iconSubtle} /> Not Yet
          </>
        )}
      </TableCell>
    ),
  },
];

export const HEADERS = [
  { label: 'Record Name', key: 'recordName' },
  { label: 'Record Type', key: 'recordType' },
  { label: 'Record Value', key: 'recordValue' },
  { label: 'Verified', key: 'hasEntry' },
];
